import { render, staticRenderFns } from "./StockEntryAddDialog.vue?vue&type=template&id=f872e924&scoped=true"
import script from "./StockEntryAddDialog.vue?vue&type=script&lang=js"
export * from "./StockEntryAddDialog.vue?vue&type=script&lang=js"
import style0 from "./StockEntryAddDialog.vue?vue&type=style&index=0&id=f872e924&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f872e924",
  null
  
)

export default component.exports